<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    Izdvojeno
                  </h2>
                  <p class="card-big-info-desc">
                    Unesite detalje
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Naziv
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="brand.title"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Naslov
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naslov"
                        v-model="brand.text_1"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Boja naslova
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="row">
                        <div class="col-10">
                          <v-swatches
                            v-model="brand.text_1_BackgroundColor"
                            show-fallback
                            fallback-input-type="color"
                            show-border
                            popover-x="left"
                          >
                            <input
                              slot="trigger"
                              v-model="brand.text_1_BackgroundColor"
                              class="form-control form-control-modern w-100"
                            />
                          </v-swatches>
                        </div>

                        <div class="col-2">
                          <v-swatches
                            v-model="brand.text_1_BackgroundColor"
                            row-length="1"
                            show-border
                            :disabled="true"
                            popover-x="left"
                          ></v-swatches>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Glavni naslov
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Glavni naslov"
                        v-model="brand.text_2"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Boja glavnog naslova
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="row">
                        <div class="col-10">
                          <v-swatches
                            v-model="brand.text_2_BackgroundColor"
                            show-fallback
                            fallback-input-type="color"
                            show-border
                            popover-x="left"
                          >
                            <input
                              slot="trigger"
                              v-model="brand.text_2_BackgroundColor"
                              class="form-control form-control-modern w-100"
                            />
                          </v-swatches>
                        </div>

                        <div class="col-2">
                          <v-swatches
                            v-model="brand.text_2_BackgroundColor"
                            row-length="1"
                            show-border
                            :disabled="true"
                            popover-x="left"
                          ></v-swatches>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Karakteristike
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Karakteristike"
                        v-model="brand.text_3"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Boja karakteristike
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="row">
                        <div class="col-10">
                          <v-swatches
                            v-model="brand.text_3_BackgroundColor"
                            show-fallback
                            fallback-input-type="color"
                            show-border
                            popover-x="left"
                          >
                            <input
                              slot="trigger"
                              v-model="brand.text_3_BackgroundColor"
                              class="form-control form-control-modern w-100"
                            />
                          </v-swatches>
                        </div>

                        <div class="col-2">
                          <v-swatches
                            v-model="brand.text_3_BackgroundColor"
                            row-length="1"
                            show-border
                            :disabled="true"
                            popover-x="left"
                          ></v-swatches>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Količina popusta
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Količina popusta"
                        v-model="brand.text_4"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Boja količine popusta
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="row">
                        <div class="col-10">
                          <v-swatches
                            v-model="brand.text_4_BackgroundColor"
                            show-fallback
                            fallback-input-type="color"
                            show-border
                            popover-x="left"
                          >
                            <input
                              slot="trigger"
                              v-model="brand.text_4_BackgroundColor"
                              class="form-control form-control-modern w-100"
                            />
                          </v-swatches>
                        </div>

                        <div class="col-2">
                          <v-swatches
                            v-model="brand.text_4_BackgroundColor"
                            row-length="1"
                            show-border
                            :disabled="true"
                            popover-x="left"
                          ></v-swatches>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Dodatni sadržaj
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Dodatni sadržaj"
                        v-model="brand.text_5"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Boja dodatnog sadržaja
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="row">
                        <div class="col-10">
                          <v-swatches
                            v-model="brand.text_5_BackgroundColor"
                            show-fallback
                            fallback-input-type="color"
                            show-border
                            popover-x="left"
                          >
                            <input
                              slot="trigger"
                              v-model="brand.text_5_BackgroundColor"
                              class="form-control form-control-modern w-100"
                            />
                          </v-swatches>
                        </div>

                        <div class="col-2">
                          <v-swatches
                            v-model="brand.text_5_BackgroundColor"
                            row-length="1"
                            show-border
                            :disabled="true"
                            popover-x="left"
                          ></v-swatches>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Pozadinska boja
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="row">
                        <div class="col-10">
                          <v-swatches
                            v-model="brand.backgroundColour"
                            show-fallback
                            fallback-input-type="color"
                            show-border
                            popover-x="left"
                          >
                            <input
                              slot="trigger"
                              v-model="brand.backgroundColour"
                              class="form-control form-control-modern w-100"
                            />
                          </v-swatches>
                        </div>

                        <div class="col-2">
                          <v-swatches
                            v-model="brand.backgroundColour"
                            row-length="1"
                            show-border
                            :disabled="true"
                            popover-x="left"
                          ></v-swatches>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Tekst dugmeta
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Tekst dugmeta"
                        v-model="brand.buttonText"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Link
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Link"
                        v-model="brand.buttonContentUrl"
                      />

                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Boja dugmeta
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="row">
                        <div class="col-10">
                          <v-swatches
                            v-model="brand.buttonBackgroundColour"
                            show-fallback
                            fallback-input-type="color"
                            popover-x="left"
                          >
                            <input
                              slot="trigger"
                              v-model="brand.buttonBackgroundColour"
                              class="form-control form-control-modern"
                            />
                          </v-swatches>
                        </div>

                        <div class="col-2">
                          <v-swatches
                            v-model="brand.buttonBackgroundColour"
                            row-length="1"
                            show-border
                            :disabled="true"
                            popover-x="left"
                          ></v-swatches>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Boja teksta dugmeta
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="row">
                        <div class="col-10">
                          <v-swatches
                            v-model="brand.buttonTextColor"
                            show-fallback
                            fallback-input-type="color"
                            popover-x="left"
                          >
                            <input
                              slot="trigger"
                              v-model="brand.buttonTextColor"
                              class="form-control form-control-modern"
                            />
                          </v-swatches>
                        </div>

                        <div class="col-2">
                          <v-swatches
                            v-model="brand.buttonTextColor"
                            row-length="1"
                            show-border
                            :disabled="true"
                            popover-x="left"
                          ></v-swatches>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Slika bannera</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="file"
                        class="form-control form-control-modern"
                        ref="photo"
                        accept="image/*"
                        @change="handlePhotoUpload"
                      />
                      <span class="form-text">
                        Učitajte sliku rezolucije 295px x 125px
                      </span>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Dostupno na</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="brand.highlightedBrandContentType"
                      >
                        <option
                          v-for="item in b2borb2cOptions"
                          :value="item.id"
                          :key="item.id"
                        >
                          {{ item.text }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div v-if="brand.highlightedBrandContentType === 1 || brand.highlightedBrandContentType === 3" class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Trenutno istaknuto B2B
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="brand.currentlyHighlighted"
                          id="discount-data-visible"
                        />
                        <label for="discount-data-visible"></label>
                      </div>
                    </div>
                  </div>

                  <div v-if="brand.highlightedBrandContentType === 2 || brand.highlightedBrandContentType === 3" class="form-group row align-items-center pb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Trenutno istaknuto B2C
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          type="checkbox"
                          v-model="brand.currentlyHighlightedB2C"
                          id="discount-data-visible"
                        />
                        <label for="discount-data-visible"></label>
                      </div>
                    </div>
                  </div>

                </div>
                <!-- preview -->
                <div>
                  <div v-if="brand"
                      class="home-banner"
                      :style="{
                        backgroundColor: brand && brand.backgroundColour,
                      }">
                      <div class="image-container">
                        <!-- <img src="assets/images/banners/vileda-banner4.png" /> -->
                        <img :src="`${posterUrl || imageUrl}`" v-if="posterUrl || imageUrl"/>
                      </div>
                      <div class="info-group">
                        <div>
                          <p :style="{color: brand && brand.text_1_BackgroundColor}">{{ brand && brand.text_1 }}</p>
                          <h2 :style="{color: brand && brand.text_2_BackgroundColor}">{{ brand && brand.text_2 }}</h2>
                        </div>
                        <div class="skew-box-group">
                          <span v-if="brand && brand.text_3" class="skew-box"
                            :style="{color: brand && brand.text_3_BackgroundColor}">{{ brand && brand.text_3 }}</span>
                          <h3 class="sale-off skew-box" :style="{color: brand && brand.text_5_BackgroundColor}">
                            <span :style="{
                        backgroundColor: brand && brand.backgroundColour,
                        color: brand && brand.text_4_BackgroundColor,
                      }">{{ brand && brand.text_4 }}</span>
                            {{ brand && brand.text_5 }}
                          </h3>
                        </div>
                        <div v-if="brand && brand.buttonText">
                          <div
                            :href="brand && brand.buttonContentUrl"
                            target="_blank"
                            class="btn font-weight-bold"
                            :style="{
                              backgroundColor: brand && brand.buttonBackgroundColour,
                              color: brand && brand.buttonTextColor,
                            }"
                            style="padding-left: 20px; padding-right: 20px; border-radius: 0 !important;"
                          >
                            {{ brand && brand.buttonText }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- preview -->
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-between">
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
            exact
            :to="{ name: 'HighlightedBrands' }"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
      <modal id="delete-modal">
        <h5 slot="header"><strong>{{ translations.deleteHighlightedCategory }}</strong></h5>
        <div slot="body">
          <span v-html="modalText">
          </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button type="button" class="btn btn-primary px-4 mx-2" @click.prevent.stop="handleDelete" data-bs-dismiss="modal">
                {{ translations.yes }}
              </button>
              <button type="button" class="btn btn-default px-4" data-bs-dismiss="modal">
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import VSwatches from "vue-swatches";
// Import the styles too, typically in App.vue or main.js
import "vue-swatches/dist/vue-swatches.css";

import { translations } from "@/mixins";
import Modal from '@/components/shared/modal/Modal.vue';
import api from "@/services/api";
import config from "@/config";

export default {
  name: "EditHighlightedBrand",
  mixins: [translations],
  components: { VSwatches, Modal },
  data() {
    return {
      posterUrl: '',
      b2borb2cOption: 3,
      b2borb2cOptions: [
        {
          id: 1,
          text: 'B2B',
        },
        {
          id: 2,
          text: 'B2C',
        },
        {
          id: 3,
          text: 'Sve',
        },
      ],
    };
  },
  computed: {
    imageUrl() {
      return this.brand?.brandImageUrl ? `${config.baseUrl}${this.brand?.brandImageUrl}` : false;
    },
    baseUrl() {
      return config.baseUrl;
    },
    brand() {
      return this.$store.getters.getHighlightedBrand;
    },
    modalText() {
      return this.translations.areYouSureHighlightedBrand.replace('{brand}', `<strong>${this.brand.title}</strong>`);
    },
  },
  methods: {
    submitForm() {
      let {
        brand
      } = this;

      if(brand.highlightedBrandContentType === 1) {
        brand.currentlyHighlightedB2C = false;
      }

      if(brand.highlightedBrandContentType === 2) {
        brand.currentlyHighlighted = false;
      }

      if (this.$refs.photo.files[0]) {
        const file = this.$refs.photo.files[0];

        brand.image = {
          file: this.brandImageUrl.split(',')[1],
          fileName: file.name,
        };
      }

      api.updateHighlightedBrand(brand).then((response) => {
        this.$toast.info(response.data.info);
        this.$router.push({ name: 'HighlightedBrands' });
      });
    },
    handlePhotoUpload() {
      const file = this.$refs.photo.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      const img = new Image();
      img.src = URL.createObjectURL(file);

      reader.onload = (e) => {
        this.brandImageUrl = e.target.result;
      };

      img.onload = () => {
        this.posterUrl = img.src;
      };
    },
    handleDelete() {
      api.deleteHighlightedBrand(this.brand.id)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'HighlightedBrands' });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
  },
  mounted() {
    this.$store.dispatch('getHighlightedBrand', this.$route.params.id);
  },
};
</script>
<style lang="scss">
.vue-swatches {
  display: block;
}

.vue-swatches__trigger__wrapper {
  display: block;
}

// preview
.home-banner {
  background-color: #1e84bc;
  font-family: 'Open Sans', sans-serif;
}

.home-banner span {
  background-color: #5fbff3;
}

.home-banner button {
  color: #1e84bc;
  background-color: white;
}

.home-banner {
  background-color: #222529;
  display: flex;
}

.home-banner .image-container {
  width: 25%;
}

.home-banner img {
  max-width: 100%;
  height: auto;
  width: 100%;
}

.home-banner .info-group {
  flex: 1;
  display: flex;
  justify-content: space-between;
  margin: 0 3rem;
}

.home-banner .info-group>div {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.home-banner .info-group>div:first-child {
  flex: 1;
}

.home-banner .info-group .skew-box-group {
  margin-right: 4rem;
}

.home-banner p {
  font-weight: 700;
  letter-spacing: 0.025em;
  font-size: 12px;
  color: #fff;
  opacity: 0.4;
  margin-bottom: 0;
  text-transform: uppercase;
  margin-left: 1rem;
  margin-top: 2rem;
}

.home-banner h2 {
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: #fff;
  text-transform: uppercase;
  margin: 0 1rem 4rem;
}

.home-banner button {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: #fff;
  background-color: black;
  padding: 1.5rem 4rem;
  margin: 2rem;
}

.home-banner button:hover {
  opacity: 0.8;
}

.home-banner .skew-box-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.home-banner span {
  font-size: 18px;
  color: #222529;
  padding: 0.8rem 1rem;
  font-weight: 700;
  background-color: #fff;
  display: inline-block;
  margin-bottom: 1rem;
  margin-left: 3rem;
}

.home-banner .sale-off {
  font-size: 18px;
  color: #fff;
  text-transform: uppercase;
  text-align: left;
  position: relative;
  margin-bottom: 0;
  margin-left: 3rem;
}

.home-banner .sale-off span {
  font-size: 26px;
  color: #fff;
  background-color: #1E84BC;
  padding: 0 0.5rem;
  margin: 0 0.5rem 0 0;
}

.home-banner .sale-off:before {
  font-size: 1rem;
  letter-spacing: 0;
  color: #fff;
  opacity: 0.6;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(-80%, -50%) rotate(-90deg);
}

.home-banner .image-container {
  width: 25%;
}

.home-banner img {
  max-width: 100%;
  height: auto;
  width: 100%;
}

.container {
  padding: 0 20px;
}

@media (min-width: 992px) {
  .container {
    max-width: 960px !important;
    padding: 0 10px;
  }
}

@media (min-width: 1270px) {
  .container {
    max-width: 1200px !important;
    padding: 0 10px;
  }
}

@media (min-width: 1480px) {
  .container {
    max-width: 1430px !important;
    padding: 0 10px;
  }
}

@media (max-width: 991px) {
  .container {
    max-width: 100%;
    padding: 0 20px;
  }
}

.skew-box{
  transform: skew(0deg, 0deg);
}

.info-group {
    flex: 1;
    display: flex;
    justify-content: space-between;
    margin: 0 3rem;

    >div {
      display: flex;
      flex-direction: column;
      justify-content: center;

      &:first-child {
        flex: 1;
      }
    }

    .skew-box-group {
      margin-right: 4rem;
    }
  }

@media (max-width: 730px) {
  .home-banner .image-container {
    display: none;
  }

  .home-banner .info-group {
    flex-direction: column;
    align-items: center;
  }
}

@media (min-width: 1482px) {
  .home-banner {
    height: 112px;
  }

  .home-banner p {
  margin-bottom: 0;
  text-transform: uppercase;
  margin-left: 1rem;
  margin-top: 20px;
  }
  
  .home-banner h2 {
    text-transform: uppercase;
    margin: 0 1rem 2.3rem;
    margin-top: -5px;
  }
  
  .skew-box-group span {
    margin-bottom: 10px;
  }
  
  .skew-box-group h3 {
    margin-top: 0px;
  }

}
// preview
</style>
